var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"lg":"3"}},[_c('admin-dashboard-main')],1),(_vm.$vuetify.breakpoint.lgAndUp)?_c('v-col',[(_vm.$vuetify.breakpoint.lgAndUp)?_c('admin-dashboard-big-calendar'):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }